import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // returns list of all the people
  createDeposit: (payload) => client.post(apiList.depositTransaction, { json: payload }),
  createWithdrawal: (payload) => client.post(apiList.withdrawalTransaction, { json: payload }),
  getPaymentAccountList : () => client.get(apiList.paymentAccount)
};

// {userId: userId, startDate: startDate, endDate: endDate}